import { takeLatest, put, call, select } from "redux-saga/effects";
import axios from "../../utils/axios";
import log from "loglevel";
import messages from "../../assets/i18n";
import getEnvParam from "../../utils/getEnvParam";

const subcontractorsFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

function* subcontractors(payload, page, token) {
	try {
		const { 
			cnpj,
			email,
			nomeFantasia,
			razaoSocial
		} = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
                listarFiltrados(
					filtros: {
						cnpj: "${cnpj ? `${cnpj}` : ''}"
						email: "${email ? `${email}` : ''}"
						nomeFantasia: "${nomeFantasia ? `${nomeFantasia}` : ''}"
						razaoSocial: "${razaoSocial ? `${razaoSocial}` : ''}"
					},
					maxResults: 20,
					pageNumber: ${page}
				) {
					id
					cnpj
					codigoABVTEX
					dataCadastro
					dataModificacao
					email
					endereco
					nomeFantasia
					razaoSocial
					telefonePrincipal
					outroTelefone
					status {
						id
						descricao
					}
                }
			}`
		};

		const { data } = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* subcontractorDetails(payload, token) {
	try {
        const { subcontractorId } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    buscarPorId (id: ${subcontractorId}){
						id
						cnpj
						codigoABVTEX
						dataCadastro
						dataModificacao
						email
						endereco
						nomeFantasia
						razaoSocial
						telefonePrincipal
						outroTelefone
						status {
							id
							descricao
						}                      
                    }
                }
            `
		};

		const { data } = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getInvoiceById(payload, token) {
	try {
        const { id } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    buscarNotaFiscalSubcontratadoPorId (idNotaFiscalSubcontratado: "${id}"){
						dataCadastro
						dataModificacao
						dataNotaFiscalRetorno
						dataNotaFiscalSaida
						fornecedor {
							id
							nome
						}
						id
						numeroNotaFiscalRetorno
						numeroNotaFiscalSaida
						pedido {
							id
						}
						quantidadePecasRetorno
						quantidadePecasSaida
						subcontratado {
							id
							nomeFantasia
							razaoSocial
						}                   
                    }
                }
            `
		};

		const { data } = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getSubcontractorInvoiceList(payload, token) {
	try {
        const { idPedido } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    buscarNotaFiscalSubcontratadoPorPedido (idPedido: "${idPedido}"){
						dataCadastro
						dataModificacao
						dataNotaFiscalRetorno
						dataNotaFiscalSaida
						fornecedor {
							id
							nome
						}
						id
						numeroNotaFiscalRetorno
						numeroNotaFiscalSaida
						pedido {
							id
						}
						quantidadePecasRetorno
						quantidadePecasSaida
						subcontratado {
							id
							nomeFantasia
							razaoSocial
						}                   
                    }
                }
            `
		};

		const { data } = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* providerSubcontractors(payload, token) {
	try {
        const { idFornecedor } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    buscarSubcontratadoPorFornecedor (idFornecedor: ${idFornecedor}){
						id
						nomeFantasia               
						cnpj
                    }
                }
            `
		};

		const data = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
		return error
	}
}

function* editSubcontractor(payload, token) {
	try {
        const { 
            id,
            razaoSocial,
            nomeFantasia,
            cnpj,
            endereco,
            telefonePrincipal,
            outroTelefone,
            email,
            codigoABVTEX,
            status,
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    atualizarSubcontratado (
                        subcontratadoInput: {
                            id: ${id}
                            razaoSocial: "${razaoSocial}"
                            nomeFantasia: "${nomeFantasia}"
                            cnpj: "${cnpj}"
                            endereco: "${endereco}"
                            telefonePrincipal: "${telefonePrincipal}"
                            outroTelefone: "${outroTelefone}"
                            email: "${email}"
                            codigoABVTEX: "${codigoABVTEX}"
							status: ${status}
                        },
                    ){
                        id                        
                    }
                }
            `
		};

		const { data } = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* newSubcontractorInvoice(payload, token) {
	try {
        const {
            dataNotaFiscalRetorno,
            dataNotaFiscalSaida,
            fornecedor,
            numeroNotaFiscalRetorno,
            numeroNotaFiscalSaida,
            pedido,
            quantidadePecasRetorno,
            quantidadePecasSaida,
            subcontratado,
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    criarNotaFiscalSubcontratado (
                        notaFiscalSubcontratadoInput: {
							dataNotaFiscalRetorno: "${dataNotaFiscalRetorno}"
							dataNotaFiscalSaida: "${dataNotaFiscalSaida}"
							fornecedor: ${fornecedor}
							numeroNotaFiscalRetorno: "${numeroNotaFiscalRetorno}"
							numeroNotaFiscalSaida: "${numeroNotaFiscalSaida}"
							pedido: "${pedido}"
							quantidadePecasRetorno: ${quantidadePecasRetorno && quantidadePecasRetorno !== "" ? `"${quantidadePecasRetorno}"` : null}   
							quantidadePecasSaida: "${quantidadePecasSaida}"
							subcontratado: ${subcontratado}
                        },
                    ){
                        id                        
                    }
                }
            `
		};

		const { data, errors } = yield call(subcontractorsFromApi, options);

		return {data, errors}
	} catch (error) {
		log.info(error);
	}
}

function* editInvoice(payload, token) {
	try {
        const {
			id,
            dataNotaFiscalRetorno,
            dataNotaFiscalSaida,
            fornecedor,
            numeroNotaFiscalRetorno,
            numeroNotaFiscalSaida,
            pedido,
            quantidadePecasRetorno,
            quantidadePecasSaida,
            subcontratado,
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    atualizarNotaFiscalSubcontratado (
                        notaFiscalSubcontratadoInput: {
							id: ${id}
							dataNotaFiscalRetorno: "${dataNotaFiscalRetorno ? dataNotaFiscalRetorno : ""}"
							dataNotaFiscalSaida: "${dataNotaFiscalSaida}"
							fornecedor: ${fornecedor}
							numeroNotaFiscalRetorno: "${numeroNotaFiscalRetorno}"
							numeroNotaFiscalSaida: "${numeroNotaFiscalSaida}"
							pedido: "${pedido}"
							quantidadePecasRetorno: ${quantidadePecasRetorno && quantidadePecasRetorno !== "" ? `"${quantidadePecasRetorno}"` : null}
							quantidadePecasSaida: "${quantidadePecasSaida}"
							subcontratado: ${subcontratado}
                        },
                    ){
                        id                        
                    }
                }
            `
		};

		const { data, errors } = yield call(subcontractorsFromApi, options);

		return {data, errors}
	} catch (error) {
		log.info(error);
	}
}

function* deleteInvoice(payload, token) {
	try {
        const {
			id,
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    deletarNotaFiscalSubcontratado (id: ${id})
                }
            `
		};

		const { data } = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* newSubcontractor(payload, token) {
	try {
        const {
            razaoSocial,
            nomeFantasia,
            cnpj,
            endereco,
            telefonePrincipal,
            outroTelefone,
            email,
            codigoABVTEX,
            status,
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    criarSubcontratado (
                        subcontratadoInput: {
                            razaoSocial: "${razaoSocial}"
                            nomeFantasia: "${nomeFantasia}"
                            cnpj: "${cnpj}"
                            endereco: "${endereco}"
                            telefonePrincipal: "${telefonePrincipal}"
                            outroTelefone: "${outroTelefone}"
                            email: "${email}"
                            codigoABVTEX: "${codigoABVTEX}"
							status: ${status}
                        },
                    ){
                        id                        
                    }
                }
            `
		};

		const { data } = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getSubcontractors(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        const nextPage = payload.page + 1;
        let result

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });
        
        if (payload.cleanTable) {
            yield put({ type: "CLEAN_SUBCONTRACTOR_LIST" });
            yield put({ type: "SET_FETCHED_SUBCONTRACTOR_DETAILS", payload: {} });
        }

		result = yield call(subcontractors, payload.filter, payload.page, token);

		if (result) {
            if (result.listarFiltrados && result.listarFiltrados.length) {
                yield put({
                    type: "SET_SUBCONTRACTOR_LIST",
                    payload: {
                        list: result.listarFiltrados,
                        hasMore: true,
                        page: nextPage,
                    }
                });
            } else {
                yield put({
                    type: "SET_SUBCONTRACTOR_LIST",
                    payload: {
                        list: result.listarFiltrados,
                        hasMore: false,
                        page: payload.page,
                    }
                });
            }
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* getSubcontractorDetails(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

		const result = yield call(subcontractorDetails, payload.payload, token);

		if (result && result.buscarPorId) {
            yield put({ type: "SET_FETCHED_SUBCONTRACTOR_DETAILS", payload: result.buscarPorId});
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* editSubcontractorDetails(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(editSubcontractor, payload.payload, token);

		if (result && result.atualizarSubcontratado) {
            yield put({ 
                type: "SET_SUBCONTRACTOR_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].registerSuccess,
                    messageType: "toast-success"
                }});
        } else {
			yield put({ 
				type: "SET_SUBCONTRACTOR_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerError,
					messageType: "toast-error"
				}});
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* createNewSubcontractor(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(newSubcontractor, payload.payload, token);
		
		if (result && result.criarSubcontratado) {
            yield put({ 
                type: "SET_SUBCONTRACTOR_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].registerSuccess,
                    messageType: "toast-success"
                }});

			yield put({ type: 'SET_GET_SUBCONTRACTOR', payload: result.criarSubcontratado.id });
        } else {
			yield put({ 
				type: "SET_SUBCONTRACTOR_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerError,
					messageType: "toast-error"
				}});
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* createNewSubcontractorInvoice(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(newSubcontractorInvoice, payload.payload, token);

		if (result && result.data && result.data.criarNotaFiscalSubcontratado) {
            yield put({ 
                type: "SET_SUBCONTRACTOR_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].registerSuccess,
                    messageType: "toast-success"
                }});

			yield put({ type: "SET_EDIT_INVOICE_ID", payload: result.data.criarNotaFiscalSubcontratado.id });
        } else {
			if (result && result.errors.length > 0) {
				yield put({ 
					type: "SET_SUBCONTRACTOR_TOAST", 
					payload: {
						showToast: true,
						message: result.errors[0].exception.message,
						messageType: "toast-error"
					}});
			} else {
				yield put({ 
					type: "SET_SUBCONTRACTOR_TOAST", 
					payload: {
						showToast: true,
						message: messages[lang].registerError,
						messageType: "toast-error"
				}});
			}
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* getOrderSubcontractorInvoiceList(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

		const resultInvoice = yield call(getSubcontractorInvoiceList, payload.payload, token);

		if (resultInvoice && resultInvoice.buscarNotaFiscalSubcontratadoPorPedido) {
			yield put({ type: "SET_SUBCONTRACTOR_INVOICE_BY_ORDER_LIST", payload: resultInvoice.buscarNotaFiscalSubcontratadoPorPedido});
            
			//busca subcontratados por fornecedor
			const result = yield call(providerSubcontractors, payload.payload, token);

			if (result.data && result.data.buscarSubcontratadoPorFornecedor) {
				yield put({ type: "SET_SUBCONTRACTOR_OPTIONS", payload: result.data.buscarSubcontratadoPorFornecedor});
			}
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* editSubcontractorInvoice(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(editInvoice, payload.payload, token);
		
		if (result && result.data && result.data.atualizarNotaFiscalSubcontratado) {
            yield put({ 
                type: "SET_SUBCONTRACTOR_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].registerSuccess,
                    messageType: "toast-success"
                }});
        } else {
			if (result && result.errors.length > 0) {
				yield put({ 
					type: "SET_SUBCONTRACTOR_TOAST", 
					payload: {
						showToast: true,
						message: result.errors[0].exception.message,
						messageType: "toast-error"
				}});
			} else {
				yield put({ 
					type: "SET_SUBCONTRACTOR_TOAST", 
					payload: {
						showToast: true,
						message: messages[lang].registerError,
						messageType: "toast-error"
				}});
			}
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* deleteSubcontractorInvoice(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(deleteInvoice, payload.payload, token);
		
		if (result && result.deletarNotaFiscalSubcontratado) {
            yield put({ 
                type: "SET_SUBCONTRACTOR_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].deleteSuccess,
                    messageType: "toast-success"
                }});
        } else {
			yield put({ 
				type: "SET_SUBCONTRACTOR_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].deleteError,
					messageType: "toast-error"
				}});
        }

        yield put({ type: "SET_SUBCONTRACTOR_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* subcontractorsNotLinkedProvider(payload, token) {
	try {
		const { fornecedorId } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUBCONTRATADO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
                buscarSubcontratadosNaoVinculadosAoFornecedor(
					idFornecedor: ${fornecedorId}
				) {
                    id	
                    nomeFantasia
                    cnpj
                }
			}`
		};

		const data = yield call(subcontractorsFromApi, options);

		return data
	} catch (error) {
		log.info(error);
		return error
	}
}


function* getSubcontractorsNotLinkedProvider(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const lang = yield select(state => state.language.name);
        
		// yield put({ type: "CLEAN_PROVIDERS_NOT_LINKED_SUBCON" });
		yield put({ type: "SET_LOADING_SUBCONTRACTORS_NOT_LINKED_PROVIDER", payload: true });

		const result = yield call(subcontractorsNotLinkedProvider, payload.payload, token);

		if (result && result.data && result.data.buscarSubcontratadosNaoVinculadosAoFornecedor) {
			// Ordenando por ordem alfabética
			let orderedResult = result.data.buscarSubcontratadosNaoVinculadosAoFornecedor.sort(function(a, b) {
				var textA = a.nomeFantasia.toUpperCase();
				var textB = b.nomeFantasia.toUpperCase();
				return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});

            yield put({ type: "SET_FETCHED_SUBCONTRACTORS_NOT_LINKED_PROVIDER", payload: orderedResult});
        } else {
			if (result.errors) {
				yield put({ 
					type: "SET_PROVIDER_TOAST", 
					payload: {
						showToast: true,
						message: result.errors ? result.errors[0].message : messages[lang].internalError,
						messageType: "toast-error"
					}});
			}
		}
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_LOADING_SUBCONTRACTORS_NOT_LINKED_PROVIDER", payload: false });
	}
}

function* getSubcontractorsByProvider(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const lang = yield select(state => state.language.name);
        
		// yield put({ type: "CLEAN_PROVIDERS_BY_SUBCONTRACTOR" });
		yield put({ type: "SET_LOADING_SUBCONTRACTORS_BY_PROVIDER", payload: true });
		const result = yield call(providerSubcontractors, payload.payload, token);

		if (result.data && result.data.buscarSubcontratadoPorFornecedor) {
			// Ordenando por ordem alfabética
			let orderedResult = result.data.buscarSubcontratadoPorFornecedor.sort(function(a, b) {
				var textA = a.nomeFantasia.toUpperCase();
				var textB = b.nomeFantasia.toUpperCase();
				return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
			});

            yield put({ type: "SET_FETCHED_SUBCONTRACTORS_BY_PROVIDER", payload: orderedResult});
        } else {
			if (result.errors) {
				yield put({ 
					type: "SET_PROVIDER_TOAST", 
					payload: {
						showToast: true,
						message: result.errors ? result.errors[0].message : messages[lang].internalError,
						messageType: "toast-error"
					}});
			}
		}

	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "SET_LOADING_SUBCONTRACTORS_BY_PROVIDER", payload: false });
	}
}

function* getSubcontractorsInvoiceById(payload) {
	try {
        yield put({ type: "SET_SUBCONTRACTOR_BY_ID_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

		const result = yield call(getInvoiceById, payload.payload, token);

		if (result && result.buscarNotaFiscalSubcontratadoPorId ) {
			yield put({ type: "SET_FETCHED_SUBCONTRACTOR_INVOICE_DETAILS", payload: result.buscarNotaFiscalSubcontratadoPorId});
        }

        yield put({ type: "SET_SUBCONTRACTOR_BY_ID_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}


// //Generator function
export function* subcontractorWatcher() {
	yield takeLatest("GET_SUBCONTRACTORS", getSubcontractors);
	yield takeLatest("GET_SUBCONTRACTOR_DETAILS", getSubcontractorDetails);
	yield takeLatest("EDIT_SUBCONTRACTOR_DETAILS", editSubcontractorDetails);
	yield takeLatest("CREATE_NEW_SUBCONTRACTOR", createNewSubcontractor);
	yield takeLatest("CREATE_NEW_SUBCONTRACTOR_INVOICE", createNewSubcontractorInvoice);
	yield takeLatest("GET_ORDER_SUBCONTRACTOR_INVOICE_LIST", getOrderSubcontractorInvoiceList);
	yield takeLatest("EDIT_SUBCONTRACTOR_INVOICE", editSubcontractorInvoice);
	yield takeLatest("GET_SUBCONTRACTORS_NOT_LINKED_PROVIDER", getSubcontractorsNotLinkedProvider);
	yield takeLatest("GET_SUBCONTRACTORS_BY_PROVIDER", getSubcontractorsByProvider);
	yield takeLatest("GET_SUBCONTRACTOR_INVOICE_BY_ID", getSubcontractorsInvoiceById);
	yield takeLatest("DELETE_SUBCONTRACTOR_INVOICE", deleteSubcontractorInvoice);
}
